import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import { GET_SYSTEM_CONFIG_URL, GET_SYSTEM_CONFIG_CCRP } from '../env.js'
import { getUrl, Upload } from './customer-support'

import storeHelper from '@/store/helper'

export class CommonService extends BaseService {
  static async getConfigSystem() {
    try {
      const response = await this.request({ auth: true }).post(GET_SYSTEM_CONFIG_URL)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // @params: { regionCode = '...', adminLocationLevel = 2 / 3}
  static async getLocationsByRegionCode(params) {
    try {
      const response = await this.request({ auth: true }).post(
        GET_SYSTEM_CONFIG_CCRP + '/cfg/get-locs-by-region',
        params
      )
      return response.data.data
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getConfigCCRP() {
    try {
      const response = await this.request({ auth: true }).post(
        GET_SYSTEM_CONFIG_CCRP + '/cfg/city-list',
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getConfigRegion() {
    try {
      const response = await this.request({ auth: true }).post(
        GET_SYSTEM_CONFIG_CCRP + '/cfg/region-list',
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getConfigDistrict(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.district-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getTypeSale(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.user-get-type'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAllRole(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.role-all'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fetchNotification(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.nbrd.list-notifications'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async countNotificationUnread() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.nbrd.count-notification-unread'),
        {
          notificationOn: 'WEB',
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async readAllNotification() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.nbrd.mark-as-read'),
        {
          notificationOn: 'WEB',
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async readOneNotification(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.nbrd.mark-as-read-by-id'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async uploadImg(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.upload-image-s3'),
        params,
        {
          headers: { 'Content-Type': 'application/json/form-data' },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
    // return Upload(getUrl('cnps.cfg.upload-image-s3'), params);
  }

  static async uploadFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.upload-files-s3'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async countDataSms(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.integ.otp.count-otp'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListFileExport(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.file.export.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async receiveFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.file.export.receive'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async maskReadFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.file.export.mark'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getNotification(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.nbrd.notify-system-for-user'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchDataSystemNews(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.nbrd.list-notify-system'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getConfigInfoChange() {
    try {
      const response = await this.request({ auth: false }).get(
        storeHelper.getUrl('cnps.scon.in4change.get-cfg')
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListAgentBank(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.agent-partner.list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getInfroGoogleApp() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.integ.config.get-email-verify')
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changePasswordGoogleApp(body = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.integ.config.update-email-verify'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}

export const UploadFile = async (formData, callback) => {
  return Upload(getUrl('cnps.cfg.upload-image-s3'), formData, callback)
}
